import { render, staticRenderFns } from "./table-row-cmp.vue?vue&type=template&id=620c4d36&scoped=true&functional=true"
import script from "./table-row-cmp.vue?vue&type=script&lang=js"
export * from "./table-row-cmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "620c4d36",
  null
  
)

export default component.exports